import * as React from 'react';
import Svg, { Path } from 'react-native-svg';

import withIconWrapper from 'app/hocs/withIconWrapper';

export default withIconWrapper(function NoticeAlert({ color, size, ...props }) {
  return (
    <Svg fill="none" height={size} viewBox="0 0 18 18" width={size} {...props}>
      <Path
        d="M8.62982 12.99C8.5343 12.99 8.44091 13.0183 8.36148 13.0714C8.28205 13.1244 8.22015 13.1999 8.18359 13.2881C8.14703 13.3764 8.13746 13.4735 8.1561 13.5672C8.17474 13.6609 8.22074 13.7469 8.28829 13.8145C8.35583 13.882 8.4419 13.928 8.53559 13.9467C8.62929 13.9653 8.7264 13.9558 8.81465 13.9192C8.90291 13.8826 8.97835 13.8207 9.03142 13.7413C9.08449 13.6619 9.11282 13.5685 9.11282 13.473C9.11282 13.3449 9.06193 13.222 8.97135 13.1314C8.88077 13.0408 8.75792 12.99 8.62982 12.99Z"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.25}
      />
      <Path
        d="M8.62482 10.687V5.46496"
        stroke={color}
        strokeLinecap="round"
        strokeMiterlimit={10}
        strokeWidth={1.25}
      />
      <Path
        d="M9.77782 1.34296C9.67201 1.12754 9.50795 0.946076 9.30424 0.819172C9.10053 0.692268 8.86532 0.625 8.62532 0.625C8.38531 0.625 8.15011 0.692268 7.9464 0.819172C7.74269 0.946076 7.57862 1.12754 7.47282 1.34296L0.735818 15.066C0.654804 15.2309 0.617136 15.4138 0.626366 15.5973C0.635596 15.7808 0.69142 15.959 0.788573 16.115C0.885727 16.271 1.02101 16.3996 1.18166 16.4889C1.34232 16.5781 1.52305 16.6249 1.70682 16.625H15.5428C15.7266 16.6249 15.9073 16.5781 16.068 16.4889C16.2286 16.3996 16.3639 16.271 16.4611 16.115C16.5582 15.959 16.614 15.7808 16.6233 15.5973C16.6325 15.4138 16.5948 15.2309 16.5138 15.066L9.77782 1.34296Z"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.25}
      />
    </Svg>
  );
});
